import { ReactElement, useEffect } from 'react';
import { Field, getIn, useFormikContext } from 'formik';
import { DateInput } from '@components';
import { iExtensionFormValues } from '@services/ExtensionService';
import { getFutureDateAfterNMonth } from '@utils';

// import styles from './ExtensionStep5.module.scss';

function ExtensionStep5(): ReactElement {
  const context = useFormikContext();
  const { values }: { values: iExtensionFormValues } = useFormikContext();
  useEffect(() => {
    if (getIn(values, 'DateToPay')) { context.setFieldTouched('DateToPay'); }
  }, [values.DateToPay]);
  return (
    <>
      <div>
        <span className="vfH2">Extension date</span>
        <Field component={DateInput} name="DateToPay" title="When will you be able to pay the total outstanding amount?" isMandatory minDate={new Date()} maxDate={getFutureDateAfterNMonth(3)} />
        <p>The date must be within 3 months from today.</p>
        <br />
      </div>
    </>
  );
}
export default ExtensionStep5;
